<div class="container pb-5 main-container">
    <!-- search -->
    <form class="search-component ml-sm-2 pr-2">
        <div *ngIf="(restaurantName$ | async) as restaurantName" class="search-container">
            <input class="ihost-control w-100" type="search" name="SearchTerm" [(ngModel)]="searchTerm"
                placeholder="{{'reservations.list.search' | translate}} {{restaurantName}}..."
                autocomplete="off" autocorrect="off">
            <button *ngIf="searchTerm != null && searchTerm.length > 0" class="btn-clear" type="button"
                (click)="searchTerm = ''">&times;</button>
        </div>
        <app-dropdown [(model)]="timeToSearch" [items]="timesToSearch" [displayProperty]="'display'"
            [valueProperty]="'value'" class="ms-2">
        </app-dropdown>
        <a class="btn btn-sm btn-main px-2 ms-2" (click)="searchReservations()">
            {{ 'reservations.list.search' | translate }}
        </a>
    </form>

    <!-- list -->
    <div class="tab-content">
        <div class="tab-pane fade show active" id="sample-tab-1" role="tabpanel">
            <table *ngIf="reservations" class="list-table-item list-table-link time-view mt-4">
                <tbody *ngFor="let reservation of reservations; let i = index" data-bs-toggle="collapse"
                    [attr.href]="'#tr-' + i" aria-expanded="false" [attr.aria-controls]="'tr-' + i">
                    <tr app-reservation-list-item [reservation]="reservation" [index]="i" [showGlobalSearchInfo]="true" [isOffline]="isOffline"></tr>
                    <!-- <tr app-compact-reservation-list-item *ngIf="compactView" [reservation]="reservation" [index]="i" [showGlobalSearchInfo]="true" [isOffline]="isOffline"></tr> -->
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- status modal -->
<app-reservation-status-modal></app-reservation-status-modal>